import { Component, Input, ViewChild, AfterViewInit, OnInit, Output, EventEmitter, ElementRef, HostListener, OnDestroy } from "@angular/core";
import { DayPilot, DayPilotCalendarComponent } from "daypilot-pro-angular";
import { CalendarOptions } from "../../models/calendar-options.model";
import { CalendarWeekDayEvent } from "../../models/calendar-weekday-event.model";
import { DateTimeModel, convertToIsoDateTime, formatDateTime, getMomentValue } from "@devwareapps/devware-cap";
import { NgbDateStruct, NgbDatepicker } from "@ng-bootstrap/ng-bootstrap";

import * as moment_ from 'moment';
import { EventDateTimeDTO } from '../../../calendar/models/event-data-time.model';
import { CalendarClickEvent, CalendarClickEventType } from "../../models/calendar-click-event.model";
const moment = moment_;

@Component({
  selector: 'app-calendar-weekday',
  templateUrl: './calendar-weekday.component.html',
  styleUrls: ['./calendar-weekday.component.scss']
})
export class CalendarWeekdayComponent implements OnInit, AfterViewInit, OnDestroy {

  @Input() options: CalendarOptions;
  @Input() events: CalendarWeekDayEvent[];
  @Input() compactView: boolean = false;

  @ViewChild("calendar", { static: false }) calendar: DayPilotCalendarComponent;

  @ViewChild("calendarBody") calendarBodyElement: ElementRef;

  @ViewChild(NgbDatepicker, { static: false }) private dp: NgbDatepicker;

  @Output() dateChange = new EventEmitter<DateTimeModel>();

  @Output() eventClick = new EventEmitter<CalendarClickEvent>();

  @Output() gotoCalendarClick = new EventEmitter<void>();

  hideCalendar = false;

  datetime: DateTimeModel;
  view: 'Day' | 'Week' | 'WorkWeek' | 'Days' | 'Resources' | 'Month' = 'WorkWeek';
  previousViewType: 'Day' | 'Week' | 'WorkWeek' | 'Days' | 'Resources';

  dateDisplay = 'September 2023';

  firstDayOfWeek = 0;

  config: DayPilot.CalendarConfig;
  calendarWidth: any;
  mobileView: boolean = false;
  interval: any;

  monthViewOptions: CalendarOptions;

  onDateSelection(date) {
    var dateModel = DateTimeModel.fromNgcDate(date, false);

    dateModel.timeZoneOffset = 0;
    //dateModel. = 'UTC';

    let isoDate = this.convertDateModelToISO(dateModel);

    isoDate = dateModel.toString(false);

    this.setStartDate(isoDate);
  }


  clearSelection() {
    this.calendar?.control?.clearSelection();
  }

  private convertDateModelToISO(dateModel: DateTimeModel): string {

    if (this.isInteger(dateModel.year) && this.isInteger(dateModel.month) && this.isInteger(dateModel.day)) {
      const year = dateModel.year.toString().padStart(2, '0');
      const month = dateModel.month.toString().padStart(2, '0');
      const day = dateModel.day.toString().padStart(2, '0');

      if (!dateModel.hour) {
        dateModel.hour = 0;
      }
      if (!dateModel.minute) {
        dateModel.minute = 0;
      }
      if (!dateModel.second) {
        dateModel.second = 0;
      }
      if (!dateModel.timeZoneOffset && dateModel.timeZoneOffset !== 0) {
        dateModel.timeZoneOffset = new Date().getTimezoneOffset();
      }

      const hour = dateModel.hour.toString().padStart(2, '0');
      const minute = dateModel.minute.toString().padStart(2, '0');
      const second = dateModel.second.toString().padStart(2, '0');

      const tzo = -dateModel.timeZoneOffset;
      const dif = tzo >= 0 ? '+' : '-';

      const timeString = this.toTimeString(dateModel);

      //let isoString = `${this.pad(year)}-${this.pad(month)}-${this.pad(day)}T${pad(hour)}:${pad(minute)}:${pad(second)}${dif}${pad(tzo / 60)}:${pad(tzo % 60)}`;

      let isoString = `${this.pad(year)}-${this.pad(month)}-${this.pad(day)}T${timeString}${dif}${this.pad(tzo / 60)}:${this.pad(tzo % 60)}`;

      return isoString;
    }
  }



  private toTimeString(dateModel: DateTimeModel): string {
    if (!dateModel.hour) {
      dateModel.hour = 0;
    }
    if (!dateModel.minute) {
      dateModel.minute = 0;
    }
    if (!dateModel.second) {
      dateModel.second = 0;
    }

    const hour = dateModel.hour.toString().padStart(2, '0');
    const minute = dateModel.minute.toString().padStart(2, '0');
    const second = dateModel.second.toString().padStart(2, '0');

    const timeString = `${this.pad(hour)}:${this.pad(minute)}:${this.pad(second)}`;

    return timeString;
  }
  private isInteger(value: any): value is number {
    return typeof value === 'number' && isFinite(value) && Math.floor(value) === value;
  }

  private pad(num) {
    const norm = Math.floor(Math.abs(num));

    return (norm < 10 ? '0' : '') + norm;
  }

  @HostListener('window:resize', ['$event.target'])
  public onResize(target) {
    this.setCalendarViewBySize();
  }

  private setCalendarViewBySize() {
    const width = this.calendarBodyElement?.nativeElement?.offsetWidth;

    this.calendarWidth = width;
    if (width < 400) {

      this.mobileView = true;
      if (this.config.viewType !== 'Day') {
        this.view = 'Day';
        this.previousViewType = this.config.viewType;
        this.viewChange(this.view);
      }
    } else {
      this.mobileView = false;
      if (this.previousViewType) {
        this.view = this.previousViewType;
        this.viewChange(this.view);
        this.previousViewType = null;
      }
    }
  }

  ngOnInit(): void {
    this.datetime = this.convertFromLocalString(this.options.startDate);
    // this.datetime = DateTimeModel.fromLocalString(this.options.startDate, false);

    // if (this.datetime.timeZoneOffset != 0) {
    //   this.datetime.hour = this.datetime.timeZoneOffset / 60;;
    // }

    if (this.compactView) {
      this.view = 'Day';
    }

    const config: DayPilot.CalendarConfig = {
      viewType: this.view as any,

      startDate: this.options.startDate || "2023-09-10",
      showHeader: true,
      onEventClick: args => { this.fireEvent(CalendarClickEventType.click, args) },
      onEventMove: args => { this.fireEvent(CalendarClickEventType.move, args); },
      onEventMoved: args => { this.fireEvent(CalendarClickEventType.moved, args); args.preventDefault(); },
      onEventSelect: args => { this.fireEvent(CalendarClickEventType.select, args) },
      onEventSelected: args => { this.fireEvent(CalendarClickEventType.selected, args) },
      onEventDoubleClick: args => { this.fireEvent(CalendarClickEventType.doubleClick, args) },
      onTimeRangeSelected: args => { this.fireEvent(CalendarClickEventType.timeRangeSelected, args) },
      onHeaderClick: args => { this.fireEvent(CalendarClickEventType.headerClick, args) },
      onEventResize: args => { this.fireEvent(CalendarClickEventType.resize, args); args.preventDefault(); },
      onEventResized: args => { this.fireEvent(CalendarClickEventType.resized, args); args.preventDefault(); },
      onEventRightClick: args => { this.fireEvent(CalendarClickEventType.rightClick, args); args.preventDefault(); },
      dayBeginsHour: 0,
      dayEndsHour: 24,
      businessBeginsHour: 8,
      businessEndsHour: 18,
      heightSpec: 'Parent100Pct'
    };

    this.setCalendarViewBySize();

    this.updateConfig(config);

    this.toggleCalendarDisplay();
  }

  ngOnDestroy(): void {
    if (this.interval) {
      clearInterval(this.interval);
    }
  }

  /**
   * Sets a 10 minute interval to hide the calendar, then show it again
   * This is a hack to workaround the trial version error, since this version is no longer supported a license isn't available
   */
  private toggleCalendarDisplay() {
    this.interval = setInterval(() => {
      this.hideCalendar = true;

      setTimeout(() => {
        // hide calendar for 50 ms
        this.hideCalendar = false;
      });

      // }, 10 * 1000);  // Toggle calendar visibility every 10 seconds (testing only)
    }, 10 * 60 * 1000);  // Toggle calendar visibility every 10 minutes
  }

  private fireEvent(eventType: CalendarClickEventType, args: any) {
    //console.log(`Calendar Event - ${name}`, args);

    this.eventClick.emit({
      eventType: eventType,
      eventData: args.e?.data,
      mouseEvent: args.originalEvent,
      fullEvent: args.e,
      preventDefault: args.preventDefault,
      start: args.start,
      end: args.end
    });
  }

  onMonthViewEventClick(event: CalendarClickEvent) {
    this.eventClick.emit(event);
  }

  viewChange(view) {
    this.updateConfig({ viewType: view });
  }

  dayOffset = 0;

  gotoToday() {
    var startDate = convertToIsoDateTime(moment().utc().format("MM/DD/YYYY"), false);

    this.setStartDate(startDate);
  }


  next() {
    const daysToOffset = this.getViewDaysOffset(true);

    this.dayOffset += daysToOffset;

    const newDate = this.addDays(this.dayOffset);

    this.setStartDate(newDate.toISOString());
  }

  previous() {
    const daysToOffset = this.getViewDaysOffset(false);

    this.dayOffset -= daysToOffset;

    const newDate = this.addDays(this.dayOffset);

    this.setStartDate(newDate.toISOString());
  }

  private getViewDaysOffset(isNext: boolean): number {
    switch (this.view) {
      case 'Day':
        return 1;
      case 'Month':
        if (isNext) {
          return this.getDaysUntilNextMonth(this.monthViewOptions.startDate);
        }
        return this.getDaysInPreviousMonth(this.monthViewOptions.startDate);
      default:
        return 7;
    }
  }

  private getDaysUntilNextMonth(startDate: string): number {
    if (!startDate) {
      return 0;
    }

    const start = new Date(startDate);
    start.setHours(0, 0, 0, 0);

    const firstOfNextMonth = new Date(
      start.getFullYear(),
      start.getMonth() + 1,
      1
    );

    return Math.ceil(
      (firstOfNextMonth.getTime() - start.getTime()) / (1000 * 60 * 60 * 24)
    );
  }

  private getDaysInPreviousMonth(startDate: string): number {
    if (!startDate) {
      return 0;
    }

    const start = new Date(startDate);

    // Day 0 of the current month = last day of previous month
    return new Date(
      start.getFullYear(),
      start.getMonth(),
      0
    ).getDate();
  }

  private setStartDate(date: string) {
    this.updateConfig({ startDate: date });

    this.datetime = this.convertFromLocalString(date);
    // this.datetime = DateTimeModel.fromLocalString(date, false);


    // if (this.datetime.timeZoneOffset != 0) {
    //   this.datetime.hour = this.datetime.timeZoneOffset / 60;;
    // }

    if (this.dp) {
      this.dp.navigateTo(this.datetime);
    }

    this.dateChange.emit(this.datetime);
  }

  private convertFromLocalString(date: string): DateTimeModel {

    let datetime = DateTimeModel.fromLocalString(date, false);

    if (datetime.timeZoneOffset > 0) {
      datetime.hour = datetime.timeZoneOffset / 60;;
    }


    if (datetime.timeZoneOffset < 0) {
      datetime.hour = 24 - (datetime.timeZoneOffset / 60);
    }

    return datetime;
  }


  private updateConfig(config: Partial<DayPilot.CalendarConfig>) {
    this.config = { ...this.config, ...config };

    switch (this.config.viewType) {
      case 'Day':
        this.dateDisplay = formatDateTime(this.config.startDate, false);
        break;
      default:
        const momentDate = getMomentValue(this.config.startDate, false, false);

        this.dateDisplay = momentDate.format('MMMM YYYY');
        break;
    }

    this.setupMonthViewOptions();
  }

  setupMonthViewOptions() {
    this.monthViewOptions = {
      startDate: this.config.startDate instanceof Date ? this.config.startDate.toISOString() : this.config.startDate as string
    }
  }

  addDays = function (days) {
    var date = new Date();
    date.setDate(date.getDate() + days);

    return date;
  }


  ngAfterViewInit(): void {
    var from = this.calendar.control.visibleStart();
    var to = this.calendar.control.visibleEnd();
    // this.ds.getEvents(from, to).subscribe(result => {
    //   this.events = result;
    // });
  }

}

